import { TILE_POSITIONS } from '../constant'

export const getTilePosition = (position, size) => {
    const size2X = `-${size * 2}px`
    const tileSize = `-${size + size * 0.55}px`
    const centerTile = `-${size + size * 0.45}px`
    const topTile = `-${size * 0.25}px`
    const topTileTop = `-${size + size * 0.4}px`
    switch (position) {
        case TILE_POSITIONS.BOTTOM_LEFT:
            return `
                left: ${size2X};
                top: 50%;
                transform: translateY(-20%);
            `
        case TILE_POSITIONS.BOTTOM_RIGHT:
            return `
                right: ${size2X};
                top: 50%;
                transform: translateY(-20%);
            `
        case TILE_POSITIONS.CENTER_LEFT:
            return `
                left: ${tileSize};
                top: 0;
            `
        case TILE_POSITIONS.CENTER_RIGHT:
            return `
                top: 0px;
                right: ${tileSize};
            `
        case TILE_POSITIONS.TOP_LEFT:
            return `
                top: ${topTileTop};
                left: ${topTile};
            `
        case TILE_POSITIONS.TOP_RIGHT:
            return `
                top: ${topTileTop};
                right: ${topTile};
            `
        case TILE_POSITIONS.CENTER:
            return `
                left: 50%;
                transform: translateX(-50%) translateY(-15px);
                top: ${centerTile};
            `
        default:
            return null
    }
}
